module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xl": ""
    }
  }, [_c('v-card', [_c('v-stepper', {
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('v-stepper-header', [_c('v-stepper-step', {
    attrs: {
      "step": "1",
      "complete": _vm.step > 1
    }
  }, [_vm._v("\n                Select Import\n                "), (_vm.importEntity) ? _c('small', [_vm._v(_vm._s(_vm._f("capitalize")(_vm.importEntity)))]) : _vm._e()]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "2",
      "complete": _vm.step > 2
    }
  }, [_vm._v("\n                File\n                "), (_vm.file) ? _c('small', [_vm._v(_vm._s(_vm.file.name))]) : _vm._e()]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "3",
      "complete": _vm.step > 3,
      "rules": [function () { return !this$1.error; }]
    }
  }, [_vm._v("Result")])], 1), _vm._v(" "), _c('v-stepper-items', [_c('v-stepper-content', {
    staticClass: "text-center",
    attrs: {
      "step": "1"
    }
  }, [_c('p', [_vm._v("Please choose if you want to Import Customers or Contacts.")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.chooseImportEntity('customers')
      }
    }
  }, [_vm._v("Customers")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.chooseImportEntity('contacts')
      }
    }
  }, [_vm._v("Contacts")])], 1), _vm._v(" "), _c('v-stepper-content', {
    staticClass: "text-center",
    attrs: {
      "step": "2"
    }
  }, [_c('p', [_vm._v("Upload the CSV file containing your " + _vm._s(_vm.importEntity) + ":")]), _vm._v(" "), _c('p', [_c('input', {
    attrs: {
      "type": "file",
      "accept": "text/csv, application/vnd.ms-excel"
    },
    on: {
      "change": _vm.chooseFile
    }
  })]), _vm._v(" "), _c('p', [_c('v-btn', {
    attrs: {
      "color": "success",
      "disabled": !_vm.file
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startUpload($event)
      }
    }
  }, [_vm._v("Start upload")])], 1)]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "3"
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "error",
      "value": !!_vm.error
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.error) + "\n                ")]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "type": "success",
      "value": !_vm.error
    }
  }, [_vm._v("\n                  " + _vm._s(_vm._f("capitalize")(_vm.importEntity)) + " successful imported\n                ")]), _vm._v(" "), (_vm.importEntity === 'customers' && !_vm.error) ? _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.customerHeaders,
      "items": _vm.updated,
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.customerID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.customerName1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.customerName2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.country))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.city))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.zipcode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.locationcode))])]
      }
    }], null, false, 3188643731)
  }) : _vm._e(), _vm._v(" "), (_vm.importEntity === 'contacts' && !_vm.error) ? _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.contactHeaders,
      "items": _vm.updated,
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.contactId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.contactText1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.contactText2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.country))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.city))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.gepardCustomerNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.contactLocationCode))])]
      }
    }], null, false, 1524487963)
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/dev-isrs-frontend-mb_dev/~/vue-loader/lib/template-compiler?{"id":"data-v-d3e479d2"}!/export/jenkins/workspace/dev-isrs-frontend-mb_dev/~/vue-loader/lib/selector.js?type=template&index=0!./client/views/ImportContactsCustomer.vue
// module id = 955
// module chunks = 1